// extracted by mini-css-extract-plugin
module.exports = {"products":"Products_products__22mgE","tables":"Products_tables__DOipM","table":"Products_table__mQjgA"};